import { useQuery } from '@tanstack/react-query';
import type AdminApiAssistantTodosSummary from '@/types/serializers/AdminApiAssistantTodosSummary';

export default function useFetchAssistantTodos() {
  return useQuery({
    queryKey: ['admin', 'assistant_todos'],
    queryFn: async () => {
      const response = await fetch('/admin/api/assistant_todos');
      if (!response.ok) {
        throw new Error('アシスタントTODOの取得に失敗しました');
      }
      return response.json() as Promise<AdminApiAssistantTodosSummary>;
    },
  });
}
